var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name === 'flow-feedback')?_c('FlowCommentable',{attrs:{"id":_vm.$route.params.id}}):(_vm.$route.name === 'flow')?_c('Flow',{attrs:{"id":_vm.$route.params.id}}):_c('Main')}
var staticRenderFns = []

export { render, staticRenderFns }